import { render, staticRenderFns } from "./ResetSlideResultsSetting.vue?vue&type=template&id=cd8f1c8a&scoped=true&"
import script from "./ResetSlideResultsSetting.vue?vue&type=script&lang=js&"
export * from "./ResetSlideResultsSetting.vue?vue&type=script&lang=js&"
import style0 from "./ResetSlideResultsSetting.vue?vue&type=style&index=0&id=cd8f1c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f1c8a",
  null
  
)

export default component.exports